import React, { useState, useEffect } from "react";
import axios from "axios";
import Config from "config";
import { borderRadius } from "react-select/src/theme";
import ChainParentDefaultLogo from "../assets/img/ChainParentDefaultLogo.png";

interface Props {
  name: string;
  id?: number;
  logo: string | undefined;
  logo_filename?: string | null;
  onClick: () => void;
}

const ChainCard: React.FC<Props> = ({ name, id, logo, logo_filename, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [logoUrl, setLogoUrl] = useState<string | null>(logo ?? null);

  const styles = {
    card: {
      display: "flex",
      flexDirection: "column" as const,
      alignItems: "center",
      width: "90px", // w-24
    },
    logoHover: {
      transform: "scale(1.08)", // Scale up slightly
      // boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)", // Lifted shadow
      // backgroundColor: "#f9fafb", // Very light background tint
    },
    logo: {
      height: "72px", // h-12
      width: "72px",
      objectFit: "contain" as const,
      cursor: "pointer",
      backgroundColor: "#ffffff", // bg-gray-50
      padding: "0.5rem 0.7rem", // p-2
      borderRadius: "8px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    name: {
      fontSize: "12px", // text-sm
      marginTop: "10px", // mt-2
      color: "#000",
      textAlign: "center" as const,
      cursor: "pointer",
    },
  };

  const dynamicLogoStyle = isHovered ? { ...styles.logo, ...styles.logoHover } : styles.logo;

  useEffect(() => {
    setLogoUrl(logo ?? null);
  }, [logo]);

  useEffect(() => {
    let cancelled = false;
    const fetchLogo = async () => {
      try {
        if (!logoUrl && typeof id === "number") {
          const resp = await axios.get(`${Config.API_SERVICE_URL}/api/chain-parent-logo/${id}`);
          if (!cancelled && resp && resp.data) {
            const returned = resp.data.logo ?? null;
            if (returned && typeof returned === "string") {
              setLogoUrl(returned.startsWith("http") ? returned : `${Config.API_SERVICE_URL}${returned}`);
            } else {
              setLogoUrl(null);
            }
          }
        }
      } catch (e) {
        // ignore errors and keep default
      }
    };
    fetchLogo();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // console.log(name.split(" ")[0][0], typeof name.split(" ")?.[1]?.[0]);

  return (
    <div
      onClick={onClick}
      style={styles.card}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {logoUrl ? (
        <img src={logoUrl} alt={name} style={dynamicLogoStyle} />
      ) : (
        <img src={ChainParentDefaultLogo} alt={name} style={dynamicLogoStyle} />
        // <div style={dynamicLogoStyle}>
        //   {name.split(" ")[0][0]}
        //   {name.split(" ")?.[1]?.[0] !== undefined ? name.split(" ")?.[1]?.[0] : ""}
        // </div>
      )}
      {/* <img src={logo} alt={name} style={dynamicLogoStyle} /> */}
      <span style={styles.name}>{name}</span>
    </div>
  );
};

export default ChainCard;
